import React from "react";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";
import { Section, PrimaryButton, SecondaryButton } from "@/components/ui-helpers";

export default function NotFound() {
  return (
    <>
      <SEO title="Page not found" />
      <Section className="pt-28 sm:pt-32">
        <div className="mx-auto max-w-2xl text-center">
          <p className="display-1 text-transparent leading-none" style={{ WebkitTextStroke: "1.5px var(--gold-hairline)" }}>404</p>
          <p className="kicker mt-6">Off the map</p>
          <h1 className="mt-3 display-2 text-white">This page has moved, or never existed</h1>
          <p className="mt-4 lede mx-auto">Let's get you back to something useful — explore our services or request a tailored quote.</p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <PrimaryButton to="/">Back home <ArrowRight className="h-4 w-4" /></PrimaryButton>
            <SecondaryButton to="/services">Browse services</SecondaryButton>
          </div>
        </div>
      </Section>
    </>
  );
}
